import * as React from 'react';

import { GoBackButton } from '../../../GoBackButton';

import * as styles from './styles.css';

export interface IFormHeaderProps {
  backToPage?: React.ReactNode;
  progressBar: React.ReactNode;
  showGoBackBtn: boolean;
  handleGoBack(): void;
  goBackText: string;
}

export function FormHeader({ backToPage, progressBar, showGoBackBtn, handleGoBack, goBackText }: IFormHeaderProps) {
  return (
    <>
      <div className={styles['top']}>
        {showGoBackBtn && <GoBackButton onClick={handleGoBack}>{goBackText}</GoBackButton>}
        {backToPage && <div className={styles['close']}>{backToPage}</div>}
      </div>
      {progressBar}
    </>
  );
}
